import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(() => ({
	"@keyframes blink": {
		"0%, 100%": { opacity: 1 },
		"50%": { opacity: 0.25 }
	},
	"@keyframes floatBlob": {
		"0%, 100%": { transform: "translate(0, 0) rotate(0deg)" },
		"33%": { transform: "translate(12px, -8px) rotate(3deg)" },
		"66%": { transform: "translate(-8px, 10px) rotate(-2deg)" }
	},
	"@keyframes coinPop": {
		"0%": { opacity: 0, transform: "scale(0.5)" },
		"60%": { opacity: 1, transform: "scale(1.1)" },
		"100%": { opacity: 1, transform: "scale(1)" }
	},
	header: {
		position: "relative",
		overflow: "hidden",
		padding: "46px 40px 40px",
		textAlign: "center",
		background: `linear-gradient(155deg, ${themeColors.colors.system.purple[400]} 0%, ${themeColors.colors.system.purple[600]} 100%)`,
		color: themeColors.colors.system.gray[50]
	},
	blobOne: {
		position: "absolute",
		width: 280,
		height: 280,
		left: -110,
		top: -120,
		borderRadius: "62% 38% 47% 53% / 44% 56% 44% 56%",
		backgroundColor: ColorUtil.hexToRgba(colors.gray[50], 0.13),
		animation: "$floatBlob 14s ease-in-out infinite",
		pointerEvents: "none"
	},
	blobTwo: {
		position: "absolute",
		width: 220,
		height: 220,
		right: -90,
		bottom: -110,
		borderRadius: "41% 59% 62% 38% / 57% 43% 57% 43%",
		backgroundColor: ColorUtil.hexToRgba(colors.beige[200], 0.18),
		animation: "$floatBlob 18s ease-in-out infinite reverse",
		pointerEvents: "none"
	},
	dotTexture: {
		position: "absolute",
		inset: 0,
		backgroundImage: `radial-gradient(${ColorUtil.hexToRgba(colors.gray[50], 0.22)} 1.1px, transparent 1.1px)`,
		backgroundSize: "20px 20px",
		opacity: 0.5,
		pointerEvents: "none"
	},
	headerContent: {
		position: "relative",
		zIndex: 2
	},
	badge: {
		display: "inline-flex",
		alignItems: "center",
		gap: 8,
		padding: "6px 14px",
		borderRadius: 999,
		backgroundColor: themeColors.colors.system.purple[50],
		color: themeColors.colors.system.gray[900],
		fontSize: "11.5px",
		fontWeight: 700,
		letterSpacing: "0.08em",
		textTransform: "uppercase"
	},
	badgeDot: {
		width: 7,
		height: 7,
		borderRadius: "50%",
		backgroundColor: themeColors.colors.system.green[400],
		animation: "$blink 1.4s infinite"
	},
	title: {
		marginTop: 22,
		maxWidth: 360,
		marginLeft: "auto",
		marginRight: "auto",
		color: themeColors.colors.system.gray[50],
		fontSize: "34px",
		fontWeight: 500,
		lineHeight: 1.2,
		letterSpacing: "-0.025em"
	},
	titleAtendente: {
		marginTop: 22,
		color: themeColors.colors.system.gray[50],
		fontSize: "20px",
		fontWeight: 400
	},
	rewardRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 12,
		marginTop: 20
	},
	rewardCard: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: "12px 16px",
		borderRadius: 12,
		backgroundColor: "rgba(255, 255, 255, 0.15)",
		color: themeColors.colors.system.gray[50],
		minWidth: 120
	},
	rewardCardText: {
		fontSize: "13px",
		fontWeight: 500,
		textAlign: "center",
		lineHeight: 1.3,
		color: themeColors.colors.system.gray[50]
	},
	rewardPlus: {
		fontSize: 20,
		fontWeight: 600,
		color: "rgba(255, 255, 255, 0.7)"
	},
	coinPop: {
		animation: "$coinPop 0.6s ease-out forwards"
	},
	valueCounter: {
		fontSize: "82px",
		fontWeight: 500,
		lineHeight: 1,
		letterSpacing: "-0.03em",
		fontVariantNumeric: "tabular-nums",
		color: themeColors.colors.system.gray[50]
	},
	valuePrefix: {
		fontSize: "34px",
		fontWeight: 400,
		color: themeColors.colors.system.gray[50],
		alignSelf: "flex-start",
		marginTop: 12
	},
	reservedText: {
		marginTop: 20,
		fontSize: "14.5px",
		fontWeight: 400,
		color: "rgba(255, 255, 255, 0.85)"
	},
	body: {
		padding: "24px 32px 28px",
		display: "flex",
		flexDirection: "column",
		gap: 14
	},
	countdownRow: {
		display: "flex",
		alignItems: "center",
		gap: 6,
		fontSize: "14.5px",
		color: themeColors.colors.system.gray[600]
	},
	countdownIcon: {
		fontSize: 15,
		color: themeColors.colors.system.gray[400]
	},
	ctaColumn: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 8
	},
	resgatarButton: {
		width: "100%",
		padding: "16px 24px",
		borderRadius: 12,
		border: "none",
		backgroundColor: themeColors.colors.system.purple[500],
		color: themeColors.colors.system.gray[50],
		fontSize: "16px",
		fontWeight: 600,
		cursor: "pointer",
		boxShadow: "0 12px 26px rgba(109, 91, 214, 0.3)",
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: themeColors.colors.system.purple[600]
		}
	},
	agoraNaoLink: {
		background: "none",
		border: "none",
		color: themeColors.colors.system.gray[600],
		fontSize: "14.5px",
		fontWeight: 400,
		cursor: "pointer",
		padding: "4px 8px",
		transition: "color 0.2s ease",
		"&:hover": {
			color: themeColors.colors.system.gray[900]
		}
	}
}))

export default useStyles
